export enum ConsentType {
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
  DATA_PROTECTION = 'DATA_PROTECTION',
  DIGITAL_DOCUMENTS_RECEIVAL = 'DIGITAL_DOCUMENTS_RECEIVAL',
  CHATBOT_USAGE = 'CHATBOT_USAGE',
}
